const MIN_ITEM_WIDTH = 164;
const MIN_ITEM_WIDTH_SMALL = 96;
export const GAP = 12;
const paddings = {
	small: 12,
	medium: 24,
	large: 24,
	extraLarge: 24,
	infinity: 24
};

// returns the size category of the given screen width
// we use breakpoints in browser slice of state
// size category is used to find out the correct paddings on both side of the container
const getSizeCategory = (breakPoints: Record<string, number>) => {
	let size = 'small';
	// eslint-disable-next-line no-restricted-syntax
	for (const [bpName, bpWidth] of Object.entries(breakPoints)) {
		if (window.innerWidth < bpWidth) {
			size = bpName;
			break;
		}
	}
	return size as keyof typeof paddings;
};

// returns the number of columns we can fit and the game item width for a given
// container area and size category
export const getNumberOfColumns = (breakPoints: Record<string, number>) => {
	// we use window width instead of container width because
	// the paddings depend on the viewport size rather than
	// container size
	const sizeCategory = getSizeCategory(breakPoints);
	// multiply by 2 because of padding left + padding right
	const paddingTotal = paddings[sizeCategory] * 2;
	// subtract the width that will be taken by padding left and right
	const gridWidth = window.innerWidth - paddingTotal;
	// minimum width of a game item
	let minWidth = MIN_ITEM_WIDTH;
	if (sizeCategory === 'small') {
		minWidth = MIN_ITEM_WIDTH_SMALL;
	}
	// let's start fitting columns into the available width
	// we start with 1 column
	let numberOfColumnsWeCanFit = 1;
	let currentRequiredWidth = numberOfColumnsWeCanFit * minWidth;
	const additionalColumnWidth = minWidth + GAP;
	// we keep adding columns
	// this means we have to add the width of an item + the width of the gap between columns
	// we keep doing this until we have filled up the available width
	while (currentRequiredWidth < gridWidth) {
		if (currentRequiredWidth + additionalColumnWidth < gridWidth) {
			currentRequiredWidth += additionalColumnWidth;
			numberOfColumnsWeCanFit += 1;
		} else {
			break;
		}
	}
	const calculatedItemWidth = (gridWidth - (numberOfColumnsWeCanFit - 1) * GAP) / numberOfColumnsWeCanFit;

	return { numberOfColumnsWeCanFit, calculatedItemWidth };
};
